module.exports = __webpack_public_path__ + "static/pirsos-horizontal-logo-911fb29b7814ebcb083021d8f2bae36f.png";